import { useCallback, useEffect, useState } from 'react';

// components
import { CommissionsIcon, FoodCostIcon, OtherCostIcon } from '@assets/icons';
import {
  Button,
  Tabs,
  TabsList,
  TabsTrigger,
  Typography,
  useSnackbar
} from '@growdash/design-system/atoms';

// context
// api
import { useRouter } from '@hooks/routes';
import CoFundingTab from '@modules/operations/components/co-funding-tab.tsx';
import { HandCoins, User } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { ManagementService } from '@modules/management/api';
import CommissionsTab from '@modules/operations/components/commissions-tab.tsx';
import UsersTab from '@modules/operations/components/user-tab.tsx';
import FoodCostTab from '@modules/operations/components/food-cost-tab.tsx';
import OtherCostTab from '@modules/operations/components/other-cost-tab.tsx';

// styles

const TABS = [
  {
    value: 'users',
    label: 'Users',
    icon: <User size={24} />
  },
  {
    value: 'commissions',
    label: 'Commissions',
    icon: <CommissionsIcon width={24} height={24} />
  },
  {
    value: 'food_cost',
    label: 'Food Cost',
    icon: <FoodCostIcon width={24} height={24} />
  },
  {
    value: 'other',
    label: 'Other Cost',
    icon: <OtherCostIcon width={24} height={24} />
  },
  {
    value: 'co-funding',
    label: 'Co Funding',
    icon: <HandCoins size={24} />
  }
];

export default function OperationsSettingsView() {
  const { enqueueSnackbar } = useSnackbar();

  const router = useRouter();
  const location = useLocation();

  const getCurrentTab = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('tab') || 'users';
  }, [location?.search]);

  useEffect(() => {
    setCurrentTab(getCurrentTab);
  }, [getCurrentTab]);

  const handleChangeTab = (newVal: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', newVal);
    router.replace(`?${searchParams.toString()}`);
    setCurrentTab(newVal);
  };

  const [currentTab, setCurrentTab] = useState(getCurrentTab);

  useEffect(() => {}, [currentTab]);

  const [subscriptionStatus, setSubscriptionStatus] = useState<any>(null);
  const [, setLoading] = useState(false);

  const fetchSubscriptionStatus = async () => {
    try {
      const subResponse = await ManagementService.fetchSubscriptionStatus();
      setSubscriptionStatus(subResponse.status);
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const fetchSubscriptionPortal = async () => {
    try {
      const subResponse = await ManagementService.fetchSubscriptionPortal();
      window.open(subResponse.url, '_blank');
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleBillingInfo = () => {
    fetchSubscriptionPortal();
  };

  useEffect(() => {
    fetchSubscriptionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='animate-fade-in'>
      <Typography variant='h4'>Group Name</Typography>

      <div className='color-[#02D2C5] mt-3'>
        <div className='flex flex-row justify-between items-center'>
          <Tabs value={currentTab} onValueChange={handleChangeTab}>
            <TabsList>
              {TABS.map(tab => (
                <TabsTrigger key={tab.value} value={tab.value}>
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
          {(subscriptionStatus === 'unpaid' ||
            subscriptionStatus === 'active' ||
            subscriptionStatus !== 'manual') && (
            <Button
              className='animate-fade-in'
              onClick={handleBillingInfo}
              style={{
                height: '42px',
                color: '#fff',
                background: '#02006DCC'
              }}
            >
              Billing information
            </Button>
          )}
        </div>

        {currentTab === 'users' && <UsersTab />}

        {currentTab === 'commissions' && <CommissionsTab />}

        {currentTab === 'food_cost' && <FoodCostTab />}

        {currentTab === 'other' && <OtherCostTab />}

        {currentTab === 'co-funding' && <CoFundingTab />}
      </div>
    </div>
  );
}
